
import FullScreenDialog from '../full-screen-dialog/FullScreenDialog';
import SettingsBar, { SettingsActionEnum } from '../settings-bar/SettingsBar';
import { useTranslation } from 'react-i18next';
import { IFormInstanceData } from '../../views/object-form-view/Models';
import { IFormTemplate } from '../../services/custom-forms-data-service/TemplateModels';
import CustomFormRunner, { CustomFormRunnerModeType, CustomFormRunnerType } from '../custom-form-runner/CustomFormRunner';
import { useRef } from 'react';
import UnsavedChangesPrompt from '../unsaved-changes-prompt/UnsavedChangesPrompt';
import { useConfirmation } from '../../contexts/confirmation-context/ConfirmationContext';
import { IeLynxObject } from "../../common/models/eLynxObject";

export type CustomFormRunnerDialogProps = {
    mode?: CustomFormRunnerModeType;
    open: boolean;
    onClose: () => void;
    model: IFormTemplate;
    instanceData?: IFormInstanceData,
    availableObjects?: IeLynxObject[] | undefined,
    startTime?: Date,
    endTime?: Date
};

export default function CustomFormRunnerDialog({
    open, 
    onClose,
    model,
    mode,
    instanceData,
    availableObjects,
    startTime,
    endTime
}: CustomFormRunnerDialogProps) {
    
    const { t } = useTranslation();
    const { confirm
    //    , acknowledge 
    } = useConfirmation();
    const customFormRunner = useRef<CustomFormRunnerType>(undefined);    

    const onCloseDialog = async (action: SettingsActionEnum): Promise<void> => {

        if (action === SettingsActionEnum.Close) {

            if (customFormRunner.current?.hasChanges()) {
                const result = await getUserConfirmation();

                if (result) {
                    // ok to cancel changes.
                    onClose();
                }
            } else {
                onClose();
            }
        }
    }

    const getUserConfirmation = async () => {

        const confirmDialogValues = {
            dialogTitle: t('cancelConfirmation.title'),
            confirmationText: t('forms.cancelAddDataText'),
            yesButtonText: t("cancelConfirmation.yesButtonText"),
            noButtonText: t("cancelConfirmation.noButtonText"),
            showConfirmationText: true,
            showYesButton: true,
            showNoButton: true
        };

        const result = await confirm(confirmDialogValues);
        return result === "yes";
    };

    return (

        <FullScreenDialog open={open} onClose={onClose}>

                <SettingsBar title={t(mode === 'add' ? 
                                        'forms.addData' : 
                                        mode === 'edit' ? 
                                        'forms.editData' : 
                                        'forms.viewData')} 
                    onClose={onCloseDialog}
                    hideAction={true} />                

                <CustomFormRunner 
                    mode={mode}
                    ref={customFormRunner}
                    onSubmit={() => onClose()}
                    model={model}
                    instanceData={instanceData}
                    availableObjects={availableObjects}
                    startTime={startTime}
                    endTime={endTime} />

                <UnsavedChangesPrompt
                        hasChanges={customFormRunner.current?.hasChanges() ?? false}
                        getUserConfirmation={getUserConfirmation}
                    /> 

        </FullScreenDialog>
        
    );
  }
